export default "__VITE_ASSET__CTJptNJ9__"